import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface SectionPageProps {
  title: string;
  // "3 series · 4 standalones · 9 of 40 read"
  meta: string;
  onBack: () => void;
  // The filter bar and the cover grid
  children: React.ReactNode;
}

// One shelf section on a page of its own: a back link, its name, then its
// covers in a wrapping grid.
const SectionPage = ({ title, meta, onBack, children }: SectionPageProps) => (
  <Box>
    <Button
      onClick={onBack}
      startIcon={<ArrowBackIcon />}
      color="inherit"
      sx={{ color: 'text.secondary', textTransform: 'none', ml: -1, mb: 1 }}
    >
      Comic Shelf
    </Button>

    <Box sx={{ display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', columnGap: 1.5, mb: 2.5 }}>
      {/* The shelf headings' hand-drawn font, a size up */}
      <Typography variant="h5" component="h1" sx={{ lineHeight: 1.2, fontSize: { xs: '2rem', sm: '2.4rem' } }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {meta}
      </Typography>
    </Box>

    {children}
  </Box>
);

export default SectionPage;
